import { Component, Vue } from 'vue-property-decorator'
@Component
export default class TableFilter extends Vue {

    showFilter = true;

    showMoreFilter() {
        this.showFilter = !this.showFilter;
    }

    get actionText() {
        return this.showFilter ? '精简搜索' : '更多搜索';
    }

    get actionIcon() {
        return !this.showFilter ? 'el-icon-arrow-down' : 'el-icon-arrow-up';
    }
}